export default "__VITE_ASSET__CrpSOEf6__"